import { useEffect, useState } from 'react';

import { ReferenceDtoFourriereDto } from 'lib_api/lib/api/gen';

import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

export const useRefFourriere = (
  callApi = true,
): ReferenceDtoFourriereDto | undefined => {
  const behaviourOnError = useHandleBackErrors();

  const [ref, setRef] = useState<ReferenceDtoFourriereDto | undefined>(
    undefined,
  );
  const referentielControllerApi = useApi().ReferentielControllerApi;

  useEffect(() => {
    if (callApi && ref === undefined) {
      referentielControllerApi
        .getValidFourriereUsingGET()
        .then(fetchedRef => {
          setRef(fetchedRef);
        })
        .catch((errorResponse: Response) => {
          behaviourOnError(errorResponse);
        });
    }
  }, [referentielControllerApi, behaviourOnError, callApi, ref]);

  return ref;
};
